// @flow

import * as React from "react";
import { head, intersection, map, reject } from "lodash";

import OptionSelector from "components/option_selector";
import {
  get_feature_options,
  should_hide_option_for_product
} from "models/catalogue";

import type { Feature, Option, Product } from "types";

type Props = {
  product: Product,
  features: Array<Feature>,
  selectedOptions: Array<Option>,
  onSelect: (Option, Option) => void
};

const OptionSelectorList = (props: Props) => {
  let { product, features, selectedOptions, onSelect } = props;
  return (
    <>
      {map(features, feature => {
        const options = reject(get_feature_options(feature), option =>
          should_hide_option_for_product(feature, option, product)
        );

        let selectedOption = head(intersection(options, selectedOptions));
        return (
          <OptionSelector
            key={feature}
            feature={feature}
            options={options}
            selectedOption={selectedOption}
            onSelect={onSelect}
          />
        );
      })}
    </>
  );
};

OptionSelectorList.displayName = "OptionSelectorList";

export default OptionSelectorList;
